<template>
  <img v-if="isViewable && card.color === 'ACORN' && card.value === 'A'" src="../assets/img/cards/ACORN-A.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'ACORN' && card.value === 'T'" src="../assets/img/cards/ACORN-T.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'ACORN' && card.value === 'K'" src="../assets/img/cards/ACORN-K.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'ACORN' && card.value === 'O'" src="../assets/img/cards/ACORN-O.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'ACORN' && card.value === 'U'" src="../assets/img/cards/ACORN-U.svg" alt="Karte" class="img-fluid">

  <img v-else-if="isViewable && card.color === 'HEART' && card.value === 'A'" src="../assets/img/cards/HEART-A.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'HEART' && card.value === 'T'" src="../assets/img/cards/HEART-T.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'HEART' && card.value === 'K'" src="../assets/img/cards/HEART-K.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'HEART' && card.value === 'O'" src="../assets/img/cards/HEART-O.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'HEART' && card.value === 'U'" src="../assets/img/cards/HEART-U.svg" alt="Karte" class="img-fluid">

  <img v-else-if="isViewable && card.color === 'LEAF' && card.value === 'A'" src="../assets/img/cards/LEAF-A.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'LEAF' && card.value === 'T'" src="../assets/img/cards/LEAF-T.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'LEAF' && card.value === 'K'" src="../assets/img/cards/LEAF-K.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'LEAF' && card.value === 'O'" src="../assets/img/cards/LEAF-O.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'LEAF' && card.value === 'U'" src="../assets/img/cards/LEAF-U.svg" alt="Karte" class="img-fluid">

  <img v-else-if="isViewable && card.color === 'CLAMP' && card.value === 'A'" src="../assets/img/cards/CLAMP-A.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'CLAMP' && card.value === 'T'" src="../assets/img/cards/CLAMP-T.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'CLAMP' && card.value === 'K'" src="../assets/img/cards/CLAMP-K.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'CLAMP' && card.value === 'O'" src="../assets/img/cards/CLAMP-O.svg" alt="Karte" class="img-fluid">
  <img v-else-if="isViewable && card.color === 'CLAMP' && card.value === 'U'" src="../assets/img/cards/CLAMP-U.svg" alt="Karte" class="img-fluid">

  <img v-else src="../assets/img/cards/Hidden-Card.svg" alt="Karte" class="img-fluid">
</template>

<script>
  export default {
    name: "Card",
    props: {
      card: {
        type: Object,
        required: true
      },
      isViewable: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style scoped>
 img {
   height: 7rem;
 }
</style>
